import { Button } from '@mui/material';
import { Grid } from '@mui/material';
import React from 'react';
import { useAuthorize } from '../hooks/use-authorize';
import { UserPermissionName } from '../models/user-permission-name';

interface CancelProps {
  onClose?: () => void;
  cancelLabel?: string;
  showCancel?: boolean;
}

interface OkProps {
  onOk?: () => void;
  okLabel?: string; // Default to "Ok"
  showOk?: boolean; // Default to true
}

interface SaveAndCancelButtonProps {
  cancel?: CancelProps; // Cancel props (optional with default values)
  ok?: OkProps; // Ok props (optional with default values)
}

const styling = {
  root: { paddingRight: '15px', paddingBottom: '10px', marginTop: 2 },
  buttonStyle: { width: '130px' },
};

export const SaveAndCancelButton = ({ cancel = {}, ok = {} }: SaveAndCancelButtonProps) => {
  // Default values for CancelProps and OkProps
  const {
    onClose = () => {}, // Default to an empty function if not provided
    cancelLabel = 'Cancel',
    showCancel = true,
  } = cancel;

  const {
    onOk = () => {}, // Default to an empty function if not provided
    okLabel = 'Ok', // Default label
    showOk = true,
  } = ok;

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Grid container justifyContent="space-between" spacing={1} style={styling.root}>
      {showCancel && (
        <Grid item>
          <Button variant="outlined" style={styling.buttonStyle} onClick={onClose}>
            {cancelLabel}
          </Button>
        </Grid>
      )}
      {showOk && (
        <Grid item>
          <Button variant="contained" style={styling.buttonStyle} onClick={onOk} disableElevation disabled={isReadOnlyPermission}>
            {okLabel}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};
